import { render, staticRenderFns } from "./BuildingSearchResultBeautify.vue?vue&type=template&id=dec166c2&scoped=true"
import script from "./BuildingSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./BuildingSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./BuildingSearchResultBeautify.vue?vue&type=style&index=0&id=dec166c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec166c2",
  null
  
)

export default component.exports